import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import intl from 'react-intl-universal';
import moment from 'moment'
import { Spin, Tooltip } from 'antd';
import ShareDatePicking from "./ShareDatePicking/ShareDatePicking";
import store from "@/store";
import { send, SendResult } from "./utils";
import "./DingtalkShare.scss";
import SearchSelectUser, {
    SelectUserItem,
    SHARE_PERMISSION
} from "./SearchSelectUsers/SearchSelectUsers";
import { SendButton } from "../widgets/widgets";
import { SendData } from "./types";
import { bindBeforeCreateShareLinkOrSendShareEmail } from "../../utils/utils";

export default function DingtalkShare({
    success
}: {
    success: (AllowComment: boolean, fileName: string) => any;
}) {
    const [fileName, setFileName] = useState();
    const [permit, setPermit] = useState<SHARE_PERMISSION>(SHARE_PERMISSION.REMARK);
    const [loading, setLoading] = useState(false);
    const [prompt, setPrompt] = useState(false);
    const [dateTime, setDateTime] = useState<moment.Moment>();
    const [list, setList] = useState<SelectUserItem[]>([]);

    useEffect(() => {
        getFileName();
    }, []);

    async function getFileName() {
        const name = await store.collaborationStore.getPDFDoc();
        setFileName(name);
    }
    function onSelectListChange(list: SelectUserItem[]) {
        setList(list);
    }
    function onChange(data: moment.Moment) {
        setDateTime(data)
    }
    async function beforeSend() {
        if (!window.__online__) {
            store.appStore.doNotifyErrors('offline');
            return;
        }
        if (!list.length) {
            store.appStore.setGlobalMessage({ type: 'error', content: intl.get('shareDlg.ShareWithEmail.emptyEmail') });
            return;
        }

        const sendData: SendData = {
            userIds: list.map(({ id, permit }) => ({ userId: id, prohibitComment: permit })),
        };
        if (dateTime) {
            sendData.deadline = dateTime.utc().format('YYYY-MM-DD HH:mm:ss:000');
        }
        setLoading(true);
        const status = await send(sendData);
        setLoading(false);
        switch (status) {
            case SendResult.Success:
                success(permit == SHARE_PERMISSION.REMARK, fileName);
                break;
            case SendResult.FileSizeOver:
                setPrompt(true);
                break;
            default:
                break;
        }
    }

    return (
        <div className="dd-share">
            <div className="dd-share__main">
                <div className="dd-share__title">
                    <h5>通过钉钉共享</h5>
                    <Tooltip placement="topLeft" title={fileName} className="dd-share__filename">
                        <span>{fileName}</span>
                    </Tooltip>
                </div>
                <p className="dd-share__desc">当邀请钉钉组织内的用户时，我们会自动通过钉钉发送工作通知消息。您可以为他人设置权限，以便他们可以查看您的文件或添加评论。</p>
                <SearchSelectUser onChange={onSelectListChange}>
                    {prompt && <p className="dd-share__exceed-limit">{intl.get('collaboration.Dlg.FileExceededSize', { fileSize: 30 })}</p>}
                </SearchSelectUser>
            </div>
            <div className="dd-share__footer">
                {!loading && <ShareDatePicking onChange={onChange} />}
                <SendButton
                    disabled={!list.length || loading}
                    onClick={bindBeforeCreateShareLinkOrSendShareEmail(beforeSend)}
                />
            </div>
            {loading && createPortal(
                <div className="dd-share__loading">
                    <Spin></Spin>
                </div>,
                document.querySelector('.ShareDlg .ant-modal-content')
            )}
        </div >
    )
}
